import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { 
  Mail, 
  Phone, 
  MapPin, 
  Send, 
  CheckCircle,
  ArrowRight,
  Sparkles,
  Globe,
  Zap,
  Clock
} from 'lucide-react';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    phone: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: '',
        email: '',
        organization: '',
        phone: '',
        message: ''
      });
    }, 3000);
  };

  const contactMethods = [
    {
      icon: Mail,
      title: "Email Connect",
      value: "info@evidentia.africa",
      description: "Reach us anytime for expert guidance",
      gradient: "gradient-primary"
    },
    {
      icon: Phone,
      title: "Direct Line",
      value: "+250788385513",
      description: "Mon-Fri, 9 AM - 6 PM CAT",
      gradient: "gradient-warm"
    },
    {
      icon: MapPin,
      title: "Our Office",
      value: "Kigali City, Gasabo",
      description: "Serving all corners of Africa",
      gradient: "gradient-nature"
    }
  ];

  return (
    <section id="contact" className="section-padding bg-gradient-to-br from-gray-50/30 via-white to-teal-50/20 relative overflow-hidden">
      
      {/* Background elements */}
      <div className="absolute inset-0 pattern-african opacity-15"></div>
      <div className="absolute top-1/3 right-1/4 w-96 h-96 gradient-warm rounded-full opacity-5 blur-3xl animate-bounce-subtle"></div>
      <div className="absolute bottom-1/4 left-1/3 w-80 h-80 gradient-nature rounded-full opacity-5 blur-3xl animate-bounce-subtle" style={{animationDelay: '1.5s'}}></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        
        {/* Simplified header */}
        <div className="mb-20"></div>

        <div className="grid lg:grid-cols-2 gap-20">
          
          {/* Contact form with African energy */}
          <div className="animate-slideInLeft">
            {!isSubmitted ? (
              <div className="card-modern relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-teal-50/30 via-white to-orange-50/20"></div>
                
                <div className="relative">
                  <div className="flex items-center space-x-4 mb-8">
                    <div className="w-16 h-16 gradient-primary rounded-3xl flex items-center justify-center shadow-xl">
                      <Zap className="w-8 h-8 text-white" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">Contact Us</h3>
                    </div>
                  </div>

                  <form onSubmit={handleSubmit} className="space-y-8">
                    
                    {/* Name & Email */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="space-y-3">
                        <label className="text-sm font-bold text-gray-700 uppercase tracking-wider">
                          Full Name *
                        </label>
                        <Input
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder="Your full name"
                          required
                          className="focus-ring h-12 text-lg font-medium border-2 border-gray-200 rounded-xl bg-white/80 backdrop-blur-sm"
                        />
                      </div>
                      <div className="space-y-3">
                        <label className="text-sm font-bold text-gray-700 uppercase tracking-wider">
                          Email Address *
                        </label>
                        <Input
                          name="email"
                          type="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="your@email.com"
                          required
                          className="focus-ring h-12 text-lg font-medium border-2 border-gray-200 rounded-xl bg-white/80 backdrop-blur-sm"
                        />
                      </div>
                    </div>

                    {/* Organization & Phone */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="space-y-3">
                        <label className="text-sm font-bold text-gray-700 uppercase tracking-wider">
                          Organization
                        </label>
                        <Input
                          name="organization"
                          value={formData.organization}
                          onChange={handleInputChange}
                          placeholder="Your organization"
                          className="focus-ring h-12 text-lg font-medium border-2 border-gray-200 rounded-xl bg-white/80 backdrop-blur-sm"
                        />
                      </div>
                      <div className="space-y-3">
                        <label className="text-sm font-bold text-gray-700 uppercase tracking-wider">
                          Phone Number
                        </label>
                        <Input
                          name="phone"
                          type="tel"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="+250 788 123 456"
                          className="focus-ring h-12 text-lg font-medium border-2 border-gray-200 rounded-xl bg-white/80 backdrop-blur-sm"
                        />
                      </div>
                    </div>

 

 

                    {/* Message */}
                    <div className="space-y-3">
                      <label className="text-sm font-bold text-gray-700 uppercase tracking-wider">
                        Message
                      </label>
                      <Textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        placeholder="Share your project goals, challenges, timeline, and how we can help you create meaningful impact..."
                        rows={6}
                        className="focus-ring text-lg font-medium border-2 border-gray-200 rounded-xl bg-white/80 backdrop-blur-sm"
                      />
                    </div>

                    <Button 
                      type="submit" 
                      className="w-full btn-primary text-lg py-6 group shadow-xl"
                    >
                      <Send className="w-6 h-6 mr-3 group-hover:rotate-12 transition-transform duration-300" />
                      Send Your Message
                      <ArrowRight className="w-6 h-6 ml-3 group-hover:translate-x-2 transition-transform duration-300" />
                    </Button>
                  </form>
                </div>
              </div>
            ) : (
              <div className="card-modern text-center relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-teal-50/50 to-emerald-50/50"></div>
                
                <div className="relative py-12">
                  <div className="w-24 h-24 gradient-primary rounded-3xl flex items-center justify-center mx-auto mb-8 shadow-2xl animate-bounce-subtle">
                    <CheckCircle className="w-12 h-12 text-white" />
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6">Message Sent Successfully!</h3>
                  <p className="text-gray-600 mb-8 font-medium text-lg leading-relaxed">
                    Thank you for reaching out! Our expert team will connect with you within 24 hours 
                    to discuss how we can help transform your M&E approach.
                  </p>
 
                </div>
              </div>
            )}
          </div>

          {/* Contact information with African vibes */}
          <div className="space-y-10 animate-slideInRight" style={{animationDelay: '0.3s'}}>
            
 

            {/* Contact methods */}
            <div className="space-y-6">
              {contactMethods.map((method, index) => {
                const Icon = method.icon;
                
                return (
                  <div key={index} className={`card-modern group hover:scale-105 transition-all duration-500 animate-fadeInUp`} style={{animationDelay: `${index * 0.1}s`}}>
                    <div className="flex items-start space-x-6">
                      <div className="relative">
                        <div className={`w-16 h-16 ${method.gradient} rounded-3xl flex items-center justify-center shadow-xl group-hover:shadow-2xl transition-all duration-300 group-hover:scale-110 group-hover:rotate-3`}>
                          <Icon className="w-8 h-8 text-white" />
                        </div>
                        <div className={`absolute -inset-2 ${method.gradient} rounded-3xl opacity-0 group-hover:opacity-20 blur-xl transition-all duration-300`}></div>
                      </div>
                      <div className="flex-1">
                        <h4 className="font-bold text-gray-900 text-xl mb-2">{method.title}</h4>
                        <p className="text-gray-800 font-bold mb-2 text-lg">{method.value}</p>
                        <p className="text-gray-600 font-medium">{method.description}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

 
          </div>
        </div>
      </div>
    </section>
  );
};